import type { Image, Persisted } from '@tunasong/schemas'
import cn from 'classnames'
import type { FC, HTMLAttributes } from 'react'
import { useImage } from '../hooks/image.hook.js'
import moduleStyles from './header-image.module.css'

interface HeaderImageProps extends HTMLAttributes<HTMLDivElement> {
  image: Persisted<Image>
}

const HeaderImg = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img {...props} className={cn(moduleStyles.headerImg, props.className)} style={props.style} />
)

export const HeaderImage: FC<HeaderImageProps> = props => {
  const { image, style, className, ...divProps } = props
  const url = useImage(image, 'large')

  return (
    <div {...divProps} className={cn(moduleStyles.container, className)} style={style}>
      <HeaderImg src={url} />
    </div>
  )
}
